import { nftrAxios } from "./axiosInstance";
import { IS_DEV } from "../constants";
// import { DataEntity, FetchNamesResponse } from "./Names";

async function fetchNFTNames(
  contractAddress: string,
  tokenId: string | number
): Promise<Name[]> {
  const body = {
    address: contractAddress,
    tokenId: tokenId,
    chainId: IS_DEV ? 5 : 1,
  };

  const { data } = await nftrAxios.post("/fetch-nft-names", body);

  return data.data;
}

export default fetchNFTNames;

export interface FetchNFTNamesResponse {
  success: boolean;
  data?: Name[] | null;
}
export interface Name {
  _id: string;
  transactionHash: string;
  name: string;
  wallet: string;
  timestamp: number;
  blockNumber: number;
  contractAddress: string;
  tokenId: string;
}
